import React from 'react';
import { connect } from 'react-redux';
import * as movieActions from 'ducks/movie';
import * as serieActions from 'ducks/serie';
import { AppState } from 'store/rootReducer';
import { push } from 'connected-react-router';
import styles from './Category.module.scss';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';
import Carousel from '../../components/Carousel/Carousel';
import { services } from '../../globals/app';
import {Box} from 'components/Box';
import { AxiosResponse } from 'axios';
import { SimilarMoviesResponse } from '../../types/api';
import YoutubeModal from 'components/YoutubeModal/YoutubeModal';
import useClickAway  from 'hooks/useClickAway';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router-dom';
import useLocalStorage from 'hooks/useLocalStorage';
import FavoriteIcon from '@material-ui/icons/Favorite';
import STREAMS from 'constants/streams';
import {
    Typography, 
    Grid, 
    Button,
    Box as BoxUI,
} from '@material-ui/core';
import { useStore } from 'contexts/store';
import useCategories from '../../hooks/useCategories';

const Category: React.FC = (props) : JSX.Element  => {
  let { state } = useStore();
  let [similarMovies, setSimilarMovies] = React.useState();
  const clickRef = React.useRef("");
  let [modal, setModal] = React.useState(false);
  const categories = useCategories( state.movie.genre_ids, props.categories );
  const history = useHistory();
  const [favorites, setValue, removeValue, itemExistToStorage] = useLocalStorage();


  useClickAway(clickRef, () => {
     setModal(false);
  });

 React.useEffect(() => {
     services.movie.getSimilarMovies(state.movie.id)
       .then((movies:AxiosResponse<SimilarMoviesResponse>) => setSimilarMovies(movies.data.results));
  },[]);

  const goTo = (route: string) => {
     history.push(route);
     window.scrollTo(0, 0);
  };

  const handleTrailerPlay = () => {
    setModal(true);
  };

  const handleClick = () => {
    if( itemExistToStorage(state.movie.id) ) {
        removeValue(state.movie.id);
    } else {
        setValue([state.movie, ...favorites]);
    }
  };

  const handleStream = (path) => {
     window.open(`${path}${state.movie.title}`);
  }

    return (
     <React.Fragment>
        <Grid container spacing={2} style={{background:`url(https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/${state.movie.poster_path})`}}>
            <Grid className={styles.container} container spacing={2}>
             <Box 
              adult={state.movie.adult}
              backdrop_path={state.movie.backdrop_path}
              genre_ids={state.movie.genre_ids}
              id={state.movie.id}
              original_language={state.movie.original_language}
              original_title={state.movie.original_title}
              overview={state.movie.overview}
              popularity={state.movie.popularity}
              poster_path={state.movie.poster_path}
              release_date={state.movie.release_date}
              title={state.movie.title}
              video={state.movie.video}
              vote_average={state.movie.vote_average}
              vote_count={state.movie.vote_count}    
              showTitle={false}  
              size={'big'}   
              onClick={handleClick}
            />
            <BoxUI className={styles.info}>        
                <Typography variant="h5" className={styles.title} color="textPrimary" gutterBottom>{state.movie.title} ({state.movie.release_date && state.movie.release_date.slice(0,4)})</Typography>

             <Grid className={styles.blockCategory}  container spacing={2}>
               {categories.map(((category: any) => {
                  return (
                    <Chip
                      className={styles.chip}
                      label={category && category.name}
                      clickable
                      color="primary"
                      variant="outlined"
                      deleteIcon={<DoneIcon />}
                    />
                  )
                }))}
            </Grid>

            <Grid className={styles.block} container spacing={2}>
              <Typography variant="subtitle2" className={styles.title} color="textPrimary" gutterBottom>{state.movie.overview}</Typography>
              </Grid>

              <Grid className={styles.block}  container spacing={2}>
              </Grid>

              <Button className={styles.buy}  onClick={handleTrailerPlay} variant="outlined" color="primary">
                <PlayArrowIcon className={styles.play} />
                 <Typography variant="subtitle2" className={styles.title} color="textPrimary" gutterBottom>Play trailer</Typography>
                </Button> 
                
                <Grid className={styles.blockCategory}  container spacing={2}>
               {STREAMS.map(((stream: any) => {
                  return (
                    <Chip
                      className={styles.chip}
                      label={stream.name}
                      clickable
                      color="primary"
                      variant="outlined"
                      clickable={true}
                      onClick={() => handleStream(stream.path)}
                      deleteIcon={<DoneIcon />}
                    />
                  )
                }))}
            </Grid>
            </BoxUI>

             


            <FavoriteIcon className={itemExistToStorage(state.movie.id) ? styles.favoriteIconActive : styles.favoriteIcon}/>

            </Grid>
         </Grid>

         <Grid ref={clickRef} className={styles.carousel} container spacing={2}>
           <Typography variant="h6" className={styles.title} color="textPrimary" gutterBottom>Other Movies you may like</Typography>
             {similarMovies && <Carousel  movies={similarMovies}/>}
              {modal && <YoutubeModal modal={modal} setModal={setModal}  />}
            <CloseIcon onClick={() => goTo('/')} className={styles.close} />
         </Grid>
     </React.Fragment>
    );
};

const mapStateToProps = (state: AppState) => ({
  categories: state.movie.categories,
});


const mapDispatchToProps = {
  push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Category);